import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { MapOnboardingTooltip } from '../../../../components/MapOnboardingTooltip';
import { MAX_DISPLAY_TRANSPORT_ACCESSIBILITY_ONBOARDING_COUNT } from '../../../../constants/map';
import { EMapService } from '../../../../types/map';
import { getOnboardingCookie, setOnboardingCookie } from './helpers';

interface ITransportAccessibilityOnboardingProps {
  children: React.ReactElement;
  serviceTypes: EMapService[];
}

export const TransportAccessibilityOnboarding: React.FC<ITransportAccessibilityOnboardingProps> = ({
  children,
  serviceTypes,
}) => {
  const [open, setOpen] = React.useState(true);
  const [timesShown, setTimesShown] = React.useState(0);

  React.useLayoutEffect(() => {
    setTimesShown(getOnboardingCookie());
  }, []);

  const hideOnboardingTooltip = React.useCallback(() => {
    setOpen(false);
    setOnboardingCookie(MAX_DISPLAY_TRANSPORT_ACCESSIBILITY_ONBOARDING_COUNT);
  }, []);

  const handleShow = React.useCallback(() => {
    setOnboardingCookie(timesShown + 1);
  }, [timesShown]);

  const hasTransportAccessibility = serviceTypes.includes(EMapService.TransportAccessibility);

  if (hasTransportAccessibility && timesShown < MAX_DISPLAY_TRANSPORT_ACCESSIBILITY_ONBOARDING_COUNT) {
    const onboardingContent = (
      <ActionAfterViewObserver triggerOnce callback={handleShow} percentVisible={1}>
        <span>Посмотрите, как похорошела транспортная доступность</span>
      </ActionAfterViewObserver>
    );

    return (
      <>
        {open && <MapOnboardingTooltip content={onboardingContent} onClose={hideOnboardingTooltip} placement="right" />}
        <span onClick={hideOnboardingTooltip}>{children}</span>
      </>
    );
  }

  return children;
};
